export default [
    {
      path: '/socials',
      name: 'socials-read',
      component: () => import('@/views/socials/socials-list/SocialsList.vue'),
      meta: {
        resource: 'Socials',
        action: 'read',
      },
    },
    {
        path: '/socials/create',
        name: 'socials-create',
        component: () => import('@/views/blog/blog-form/BlogForm.vue'),
        meta: {
          resource: 'Socials',
          action: 'create',
        },
    },
    {
      path: '/socials-category',
      name: 'socials-category-read',
      component: () => import('@/views/socials/category-list/CategoryList.vue'),
      meta: {
        resource: 'Social Categories',
        action: 'read',
      },
    },
    {
        path: '/socials-category/create',
        name: 'socials-category-create',
        component: () => import('@/views/blog/blog-form/BlogForm.vue'),
        meta: {
          resource: 'Social Categories',
          action: 'create',
        },
    },
    
    
  ]
  